<template>
  <div class="page-empty-message"
       :class="[
         `page-empty-message--${model}`
       ]"
  >
    <div class="header">
      <ym-img v-if="type === 'default'"
              class="default"
              :src="require('@/assets/img/empty_data/default.png')"
              alt=""
      />
      <ym-img v-if="type === 'course'"
              class="course"
              :src="require('@/assets/img/empty_data/course.png')"
              alt=""
      />
      <ym-img v-if="type === 'work'"
              class="work"
              :src="require('@/assets/img/empty_data/work.png')"
              alt=""
      />
      <ym-img v-if="type === 'address'"
              class="address"
              :src="require('@/assets/img/empty_data/address.png')"
              alt=""
      />
      <ym-img v-if="type === 'message'"
              class="message"
              :src="require('@/assets/img/empty_data/message.png')"
              alt=""
      />
      <ym-img v-if="type === 'lock'"
              class="lock"
              :src="require('@/assets/img/empty_data/lock.png')"
              alt=""
      />
      <ym-img v-if="type === 'million-read'"
              class="million-read"
              :src="require('@/assets/img/empty_data/million_read.png')"
              alt=""
      />
      <span class="hint"
            v-html="hint"
      ></span>
    </div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'PageErrorMessage',
    props: {
      type: {
        type: String,
        default: 'default',
      },
      hint: {
        type: String,
        default: '暂无数据',
      },
      model: {
        type: String,
        default: 'page',
        validator(val) {
          return [
            'page',
            'content',
          ].includes(val);
        },
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-empty-message {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: @color-white;

    &--page {
      .header {
        padding-top: 274px;
      }
    }
  }

  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .default, .work {
    width: 320px;
    height: 290px;
  }

  .course,
  .address,
  .message {
    width: 324px;
    height: 290px;
  }

  .lock {
    width: 320px;
    height: 290px;
  }

  .hint {
    margin-top: @size-base;
    color: @color-text-disabled;
    font-size: 30px;
    text-align: center;
  }

  .million-read {
    width: 320px;
    height: 320px;
  }

  .empty-page {
    margin-top: @size-small;
  }

</style>
